export default __webpack_public_path__ + "static/media/ru.7d45d7aa.png";